<template>
  <div style="height: calc(100% - 110px);">
    <!-- 已提报 或 历史月 -->
    <!-- <template v-if="isReported"> -->
      <div class="analysis-wrapper">
        <div style="background: #ffffff;" v-if="isAllPlan">
          <store-tabs :form="form" @change="hadelTabsChange" @tabsHeight="tabsHeight" ref="tabs"></store-tabs>
        </div>
        <div class="header-title">
            <el-row type="flex" justify="space-between" align="middle">
              <div class="title">
                <span>预估监控</span>
                <!-- <el-tooltip class="item" effect="dark" content="0≤|差异率|≤0.2，产品占比≥80%为A，50%≤产品占比＜80%为B，产品占比＜50%为C 。" placement="top-start" :open-delay="1000">
                  <span class="el-icon-warning-outline"></span>  
                </el-tooltip> -->
              </div>
              <el-radio-group v-model="radio" size="mini" @change="timeType">
                <el-radio-button label="日"></el-radio-button>
                <el-radio-button label="月"></el-radio-button>
                <el-radio-button label="季度"></el-radio-button>
                <el-radio-button label="年"></el-radio-button>
                <el-radio-button label="自定义"></el-radio-button>
                <monthMultiSelect v-model="month" :hideInput="true" class="monthSelect" ref="monthSelect" @monthMulti="monthMulti" @click.native="timeMonths"></monthMultiSelect>
              </el-radio-group>
            </el-row>
          </div>
        
        <div class="analysis-content" :style="`height:${storeTabsHeight}`">
          <div class="charts-wrapper" v-if="JSON.stringify(formData) !== '{}'">
          <!-- <div class="charts-wrapper" v-if="radio === '月' && JSON.stringify(formData) !== '{}'"> -->
            <!-- <scatter :form="formData" ref="scatter"></scatter> -->
            <table-analysis-3 :form="formData" :radio="radio" ref="scatter3" v-if="radio != '年'"></table-analysis-3>
            <table-analysis-1 :form="formData" :radio="radio" ref="scatter1" v-if="isQuarter"></table-analysis-1>
            <table-analysis-2 :form="formData" :radio="radio" :months="months" ref="scatter2"></table-analysis-2>
          </div>
          <div class="charts-wrapper" v-if="JSON.stringify(formData) !== '{}'">
          <!-- <div class="charts-wrapper" v-if="radio === '日' && JSON.stringify(formData) !== '{}'"> -->
            <bar :form="formData" :radio="radio" ref="bar" v-if="radio == '年'"></bar>
            <pie :form="formData" :timeType="radio" ref="pie" v-if="isQuarter && radio != '年'"></pie>
          </div>
        </div>
      </div>
    <!-- </template> -->
    <!-- 未提报 -->
    <!-- <template v-else>
      <div class="wrapper">
        <div class="no-data">
          <span class="el-icon-document-delete"></span>
          <div>暂无数据</div>
        </div>
      </div>
    </template> -->
  </div>
</template>

<script>
import storeTabs from '@/views/preSalePlan/components/mainContent/estimateAnalysis/store-tabs/store-tabs';
import scatter from './scatter/scatter'
import tableAnalysis3 from './table-analysis/table-analysis-3'
import tableAnalysis1 from './table-analysis/table-analysis-1'
import tableAnalysis2 from './table-analysis/table-analysis-2'
import monthMultiSelect  from './monthMultiSelect/monthMultiSelect'
import pie from './pie/pie'
// import bar from './bar/bar'
import bar from './bar/bar-1.vue'

import mixin from '@/views/preSalePlan/utils/mixin.js'
export default {
  mixins: [mixin],
  components: { storeTabs, scatter, tableAnalysis1, tableAnalysis2, tableAnalysis3, pie, bar, monthMultiSelect  },
  props: ['form'],
  data() {
    return {
      radio: '月',
      formData: {},
      storeTabsHeight: 'calc(100% - 80px)',
      month: '',
      months: ''
    }
  },
  computed: {
    isQuarter() {
      return this.radio != '季度' && this.radio != '自定义'
    }
  },
  mounted() {
    this.$set(this.formData, 'planTime', this.form.planTime);
    this.dayType()
    this.addListener_refresh();
    this.$store.dispatch('preSalePlan/set_timeType', this.radio);
    // this.formInit();
    // 全平台权限
    // 在storeTabs组件执行初始化方法，并默认加载第一个店铺数据

    // 店铺权限
    // 隐藏了storeTabs组件， 故直接初始化
    this.storeInit();
  },
  activated() {
    this.addListener_refresh()
  },
  methods: {
    dayType() {  //当前月展示日历史月和未来月展示月
      let time = JSON.parse(JSON.stringify(this.form.planTime))
      let dateVal = parseInt(this.form.planTime)
      let mounthVal = parseInt(time.substr(time.length-2,2))
      let date = new Date
      if(dateVal == date.getFullYear() && date.getMonth()+1 == mounthVal) {
        this.radio = '日'
      }else {
        this.radio = '月'
      }
    },
    addListener_refresh() {
      this.$bus.$off('refresh');
      this.$bus.$on('refresh', _=>{
        this.$nextTick(_=>{
          // this.formInit();
          this.$set(this.formData, 'planTime', this.form.planTime);
          this.storeInit();
          setTimeout(_=>{
            this.chartInit();
          },300)
        })
      });
    },
    initTabTime() {
      this.$refs['scatter1'] && this.$refs['scatter1'].init()
      this.$refs['scatter2'] && this.$refs['scatter2'].init()
      this.$refs['scatter3'] && this.$refs['scatter3'].init(this.months)
      this.$refs['pie'] && this.$refs['pie'].init()
      let riado = this.radio == '自定义' ? '季度' : this.radio
      this.$store.dispatch('preSalePlan/set_timeType', riado);
    },
    timeType() {
      if(this.radio == '自定义') {
        this.$refs.monthSelect.visible = true
      }else {
        this.$refs.monthSelect.visible = false
        this.$refs.monthSelect.init()
        this.month = ''
        this.months = ''
        this.initTabTime()
      }
    },
    timeMonths() {
      this.radio = '自定义'
      this.$refs.monthSelect.visible = true
    },
    monthMulti(months) {
      this.months = months
      this.initTabTime()
    },
    // formInit() {
    //   this.formData = {};
    //   this.$set(this.formData, 'storeId', this.storeId);
    //   this.$set(this.formData, 'planTime', this.form.planTime);
    //   this.$set(this.formData, 'privilegeId', this.storeId);
    // },
    hadelTabsChange({storeId, storeName,type}) {
      // this.$set(this.formData, 'storeId', this.storeId);
      this.$set(this.formData, 'privilegeId', this.storeId);
      this.formData['storeId'] = storeId;
      this.formData['storeName'] = storeName;
      if(type) {
        this.chartInit();
      } 
    },
    storeInit() {
      this.isAllPlan && this.$refs['tabs'] && this.$refs['tabs'].init();
      !this.isAllPlan && this.hadelTabsChange({
        storeId: this.storeId,
        storeName: sessionStorage.getItem("storeName"),
      })
    },
    chartInit() {
      this.$nextTick(_=>{
        this.dayType()
          setTimeout(() => {
            this.$refs['bar'] && this.$refs['bar'].init();
            this.$refs['pie'] && this.$refs['pie'].init();
            this.$refs['scatter1'] && this.$refs['scatter1'].init();
            this.$refs['scatter2'] && this.$refs['scatter2'].init();
            this.$refs['scatter3'] && this.$refs['scatter3'].init();
          }, 300);
      })
    },
    tabsHeight(type) {
      this.$nextTick(_=>{
        let tabsHeight = this.$refs.tabs.$el.offsetHeight + 28
        this.storeTabsHeight = type ? `calc(100% - ${tabsHeight + 'px'})` : 'calc(100% - 80px)'
      })
      
    }
  }
}
</script>

<style lang="stylus" scoped>
  .header-title
    margin 10px 15px
    position relative
  .title
    font-size 14px
    font-weight bold
    color #333

  .charts-wrapper
    width 100%
    display block
    // height 100%
    &>div
      flex 1
      margin-bottom 10px
  >>> .chart-scatter
    margin 0 50px
  >>> .chart-pie
    height 100%

  >>> .chart-scatter
    height 100%
    background #fff
  >>> .chart-pie
    width 100%
    background #fff
    position relative
  >>> .chart-bar
    width 100%
    height 100%
    background #fff

  .wrapper
    background #ffffff
    height 100%
  >>> .no-data
    color #c6c6c6
    position relative
    top 150px
    text-align center
    [class*="el-icon"]
      font-size 36px
      margin-bottom 15px

  .analysis-wrapper
    background #ffffff
    padding 15px 0
    height 100%
    box-sizing border-box
    overflow hidden
  .analysis-content
    // height calc(100% - 78px)
    overflow scroll

  .filed
    position fixed
    top 225px
    padding-bottom: 10px 
    right 30px
    z-index 50
  .monthSelect
    position absolute;
    display inline-block;
    cursor pointer
    width 68px;
    right 0px;
    height 28px;
</style>